import { styled } from "@mui/material";

import Modal from "../../../../../../../components/Generic/Modal";

export const ProductModal = styled(Modal)(() => ({
  minWidth: "90vw",
}));

export const GridContainer = styled("div")(() => ({
  width: "100%",
  fontFamily: "Manrope !important",
  flex: 1,
  flexDirection: "column",
  paddingBottom: "15px",
  alignItems: "center",
  justifyContent: "center",
}));
